// The root of the customer portal. Ordering is always scoped to one store —
// a customer arrives on /r/{restaurant}/s/{store} from a QR code, a table
// card, or the store's own link — so there is nothing to show here. That is
// not a reason to serve a white screen (V4-9): say so, in the brand's voice.

import type { JSX } from 'react';

import { Logo } from '../components/Logo';

export function NeedsStore(): JSX.Element {
  return (
    <main className="needs-store">
      <div className="needs-store-card">
        <div className="needs-store-mark">
          <Logo height={28} />
        </div>
        <h1>This link needs a store</h1>
        <p>
          Ordering happens on a store’s own page. Scan the QR code on your table, or use the
          link the restaurant gave you — it looks like
          <code>/r/…/s/…</code>.
        </p>
        <p className="needs-store-quiet">
          If you followed a link here and landed on this page, the link is incomplete.
        </p>
      </div>
    </main>
  );
}
